import React, { Component } from 'react';
import { Bubble } from './Bubble';
import { Heart } from './Heart';
import { NewHeart } from './newheart';
import { PopUp } from './Popup';

import { HubConnectionBuilder, HttpTransportType } from '@aspnet/signalr';
import ErrorPopup from './errorpopup';
import { Exploder } from './exploder';

export class BubbleContainer extends Component {

    fetch_retry = async (url, options, n) => {
        try {
            return await fetch(url, options);
        } catch (err) {
            if (n === 1) throw err;
            return await this.fetch_retry(url, options, n - 1);
        }
    };

    timer = -1;
    hostname = "https://filerzh.azurewebsites.net";
    // hostname = "https://localhost:5003";

    constructor(props) {
        super(props);

        this.state = {
            currentCount: 0,
            bubbles: [],
            newBubbleValue: "",   
            previousSuggestedText: "", // Store the last suggested text
   
            connectionStarted: false,
            adjustedHeight: "80%",
            bubbleLikes: [],
            hearts: [],
            showError: false
        };

        this.addBubbleStore = this.addBubbleStore.bind(this);
        this.addBubble = this.addBubble.bind(this);
        this.initialiseBubbles = this.initialiseBubbles.bind(this);
        this.handleNewBubbleValueChange = this.handleNewBubbleValueChange.bind(this);
        this.unselectAll = this.unselectAll.bind(this);
        this.selectBubble = this.selectBubble.bind(this);
        this.onLikeHandler = this.onLikeHandler.bind(this);
        this.onDislikeHandler = this.onDislikeHandler.bind(this);
        this.deleteBubbleStore = this.deleteBubbleStore.bind(this);
        this.handleNewLike = this.handleNewLike.bind(this);
        this.onErrorClick = this.onErrorClick.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.newHeart = this.newHeart.bind(this);
        this.suggestBubble = this.suggestBubble.bind(this);

        try {
            this.hubConnection = new HubConnectionBuilder()
                .withUrl(this.hostname + '/bubbleTextHub', {
                    skipNegotiation: true,
                    transport: HttpTransportType.WebSockets,
                })
                .build();

            this.hubConnection.start().then(() => {

                this.hubConnection.on('newBubbleText', (data) => {
                    this.setState({
                        bubbles: [...this.state.bubbles, data]
                    });
                });

                this.hubConnection.on('newBubbleLike', (data) => {
                    this.handleNewLike(data);
                });

                this.setState({ connectionStarted: true });
                this.hubConnection.invoke('initialise');
            });
        } catch (e) {}

        this.initialiseBubbles();
    }

    async suggestBubble() {
        try {
            const { newBubbleValue, previousSuggestedText } = this.state;

            // Check if the current text is the same as the previous suggestion
            const userInput = "" === previousSuggestedText ? "" : newBubbleValue;
    
    
            // Build query string only if userInput is not null/empty
            const query = userInput
                ? `?input=${encodeURIComponent(userInput)}`
                : "";
    
            const response = await this.fetch_retry(
                `${this.hostname}/api/BubbleText/suggest${query}`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                },
                5
            );
    
            if (response.status === 200) {
                const data = await response.text();
                this.setState({ newBubbleValue: data });
                this.setState({ previousSuggestedText: "" });
    
                 // Manually resize the textarea after updating the value
                if (this.bubbleInput) {
                    this.bubbleInput.style.height = "auto"; // Reset height to auto
                    this.bubbleInput.style.height = `${this.bubbleInput.scrollHeight}px`; // Set height to scrollHeight
                }
            }
        } catch (err) {
            console.error("Error getting suggestion", err);
        }
    }

    handleNewLike(data) {
        if (data.likes > 0 && data != null) {
            const bubbleItem = document.getElementById("bubble_" + data.bubbleTextId);
            if (bubbleItem) {
                const rect = bubbleItem.getBoundingClientRect();
                const heart = new NewHeart();
                heart.explode(
                    rect.x + rect.width / 2,
                    rect.y + rect.height / 2,
                    400,
                    1000,
                    20
                );
            }
        }

        const bubble = this.state.bubbles.find(b => b.id === data.bubbleTextId);
        if (bubble) {
            if (data.likes > 0) bubble.likes += data.likes;
            if (data.dislikes > 0) bubble.dislikes += data.dislikes;

            this.setState({ bubbles: this.state.bubbles });
        }
    }

    newHeart(xpos, ypos) {
        const colors = ["#6dcbe8", "#ff6060", "#addf76", "#4ee2bf", "#da6aee"];
        return {
            userId: this.props.userId,
            x: xpos,
            bottom_y: ypos,
            animation_delay: 4,
            color: colors[Math.floor(Math.random() * colors.length)]
        };
    }

    addBubble() {
        const Sentiment = require('sentiment');
        const sentiment = new Sentiment();

        const userInput = this.state.newBubbleValue;
        const result = sentiment.analyze(userInput);

        if (result.score > 0) {
            this.addBubbleStore(userInput, this.props.userId, 0, 0);
            this.setState({ newBubbleValue: "" });
        } else {
            this.setState({ showError: true });
        }
    }

    async addBubbleStore(text, userId, likes, dislikes) {
        const response = await this.fetch_retry(
            this.hostname + "/api/BubbleText/",
            {
                method: "PUT",
                body: JSON.stringify({ text, userId, likes, dislikes }),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            },
            5
        );

        if (response.status === 200) {
            const data = await response.json();
            this.setState({
                bubbles: [
                    ...this.state.bubbles,
                    { text, likes, dislikes, selected: false, userId, id: data.id, isNew: true }
                ]
            });
        }
    }

    deleteBubbleStore(id, element) {
        if (element) {
            const bubbleItem = document.getElementById("bubble_" + element.props.id);
            if (bubbleItem) {
                const rect = bubbleItem.getBoundingClientRect();
                const exploder = new Exploder();
                exploder.explode(
                    rect.x + rect.width / 2,
                    rect.y + rect.height / 2,
                    rect.width * 2,
                    rect.height * 2,
                    100
                );
            }
        }

        this.fetch_retry(
            this.hostname + "/api/BubbleText?userId=" + this.props.userId + "&id=" + id,
            { method: "DELETE" },
            5
        ).then(res => {
            if (res.status === 200) {
                const bubbles = this.state.bubbles.filter(b => b.id !== id);
                this.setState({ bubbles });
            }
        });
    }
    handleNewBubbleValueChange = (e) => {
        this.setState({ newBubbleValue: e.target.value }, () => {
            const el = this.bubbleInput;
            if (!el) return;
    
            el.style.height = "auto";
            el.style.height = el.scrollHeight + "px";
        });
    };
   

    unselectAll() {
        this.setState({
            bubbles: this.state.bubbles.map(b => ({ ...b, selected: false }))
        });
    }

    selectBubble(id) {
        this.setState({
            bubbles: this.state.bubbles.map(b =>
                b.id === id ? { ...b, selected: true, isNew: false } : b
            )
        });

        if (this.timerId > 0) clearTimeout(this.timerId);
        this.timerId = setTimeout(() => this.unselectAll(), 10000);
    }

    onTouchMove() {}

    onLikeHandler(id, element) {
        this.fetch_retry(this.hostname + "/api/BubbleLike/", {
            method: "PUT",
            body: JSON.stringify({ bubbleTextId: id, userId: this.props.userId, likes: 1, dislikes: 0 }),
            headers: { "Content-Type": "application/json" }
        }, 5);
    }

    onDislikeHandler(id) {
        this.fetch_retry(this.hostname + "/api/BubbleLike/", {
            method: "PUT",
            body: JSON.stringify({ bubbleTextId: id, userId: this.props.userId, likes: 0, dislikes: 1 }),
            headers: { "Content-Type": "application/json" }
        }, 5);
    }

    onErrorClick() {
        this.setState({ showError: false });
    }
async initialiseBubbles() {
    let dataWithPosition = [];

    const response = await this.fetch_retry(
        this.hostname + "/api/BubbleText/allResultsFromId?id=0&userId=" + this.props.userId,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        },
        5
    );

    if (response.status !== 200) return;

    const likesBoundry = [-999, -10, -3, 0, 1, 5, 10, 20, 50];
    const likesSizes = [10, 20, 30, 40, 50, 60, 70, 80, 100];

    const data = await response.json();

    dataWithPosition = data.map(o => {
        let sizeLookup = likesSizes[
            likesBoundry.findIndex(fi => fi > (o.likes - o.dislikes))
        ];

        if (o.mydislikes > 0) sizeLookup = sizeLookup / 2;

        o.bubble_size = sizeLookup + Math.floor(Math.random() * 20 + 1);
        o.bubble_pos = Math.floor(Math.random() * 70 + 1);
        o.blur_size = Math.floor(Math.random() * 3 + 1);
        o.animation_delay = 10 + Math.floor(Math.random() * 18);
        o.random_margin = 50 + Math.floor(Math.random() * 100);
        o.selected = false;
        o.isNew = true;

        return o;
    });

    const response2 = await this.fetch_retry(
        this.hostname + "/api/BubbleLike/allMyLikes?userId=" + this.props.userId,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        },
        5
    );

    if (response2.status === 200) {
        const likesData = await response2.json();

        likesData.forEach(likes => {
            const item = dataWithPosition.find(dp => dp.id === likes.bubbleTextId);
            if (item) {
                item.mylikes = likes.likes;
                item.mydislikes = likes.dislikes;
                item.isNew = false;
            }
        });
    }

    const filtered = dataWithPosition.filter(
        v => v.mydislikes == null || v.mydislikes === 0
    );

    this.setState({
        bubbles: filtered
    });
}

    render() {
        const that = this;

        return (
            <div className="container">
               <div className="container">
               <textarea
                    ref={el => (this.bubbleInput = el)}
                    value={this.state.newBubbleValue}
                    placeholder="post something blissful.."
                    onChange={(e) => {
                        this.handleNewBubbleValueChange(e);
                        e.target.style.height = "auto"; // Reset height to auto to shrink if needed
                        e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight
                    }}
                    rows={1}
                    style={{
                        width: "100%",
                        resize: "none", // Disable manual resizing to avoid conflicts
                        overflow: "hidden"
                    }}
                />
                </div>

                {this.state.showError &&
                    <ErrorPopup
                        errorText="Please make sure your post is positive"
                        onClick={this.onErrorClick}
                    />
                }

                <button className="btn btn-primary" onClick={this.addBubble}>
                    Add bubble
                </button>

                <button
                    className="btn btn-secondary"
                    style={{ marginLeft: "8px" }}
                    onClick={this.suggestBubble}
                >
                    Suggest
                </button>

                <div className="content" style={{ height: this.state.adjustedHeight + "px" }}>
                    {this.state.bubbles.map((o, i) => (
                        <Bubble
                            key={"bubbleitem-" + i}
                            {...o}
                            onDeleteHandler={that.deleteBubbleStore}
                            onLikeHandler={that.onLikeHandler}
                            onDislikeHandler={that.onDislikeHandler}
                            unselectAll={that.unselectAll}
                            selectBubble={that.selectBubble}
                            opened={o.selected}
                        />
                    ))}
                </div>
            </div>
        );
    }
}
